import { render, staticRenderFns } from "./SelectResource.vue?vue&type=template&id=359169ea"
import script from "./SelectResource.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectResource.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('359169ea')) {
      api.createRecord('359169ea', component.options)
    } else {
      api.reload('359169ea', component.options)
    }
    module.hot.accept("./SelectResource.vue?vue&type=template&id=359169ea", function () {
      api.rerender('359169ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/ambience/resource/components/SelectResource.vue"
export default component.exports